import { Avatar, Box, List, Text } from '@factorialco/deprecated-design-system'
import {
  ProfileEmployeeMembershipFragment,
  ProfileEmployeeTeamFragment,
} from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import TeamName from './TeamName'
import Options from './_Options'

interface Props {
  isTerminated: boolean
  teamMemberships: ProfileEmployeeMembershipFragment[]
  canManageTeams: boolean
}

const TeamMemberships = ({ teamMemberships, isTerminated, canManageTeams }: Props) => {
  const { navigation } = useNavigation()

  if (teamMemberships.length === 0) {
    return (
      <Box
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        padding="s24"
        border={{
          all: {
            style: 'solid',
            width: 's1',
            color: 'grey400',
          },
        }}
        borderRadius={{
          all: 'abs008',
        }}
      >
        <Text color="grey800" weight="normal" size="200">
          {i18n.t('employee_form.teams_info.no_teams')}
        </Text>
      </Box>
    )
  }

  const getTo = (team: ProfileEmployeeTeamFragment) => {
    return navigation.employees.teams.id.fullPath({ id: team.id })
  }

  return (
    <List>
      {teamMemberships.map((teamMembership) => {
        const team = teamMembership.team
        if (!team) return <></>
        return (
          <List.Item key={`team-membership-${team.id}`}>
            <Box
              flexDirection="row"
              alignItems="center"
              width="full"
              justifyContent="spaceBetween"
              gap="s24"
            >
              <Box flexDirection="row" minWidth="none" gap="s24">
                <Avatar label={team.name} />
                <Box gap="s2" minWidth="none">
                  <TeamName teamName={team.name} />
                  <List.Description>
                    {i18n.tp('teams.count_employee', {
                      count: team.memberships.length,
                    })}
                  </List.Description>
                </Box>
              </Box>
              {!isTerminated && (
                <Options
                  to={getTo(team)}
                  canManageTeams={canManageTeams}
                  teamMembership={teamMembership}
                />
              )}
            </Box>
          </List.Item>
        )
      })}
    </List>
  )
}

export default TeamMemberships
